import { normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    title: _ctx.addon === 'trapper' ? _ctx.$t('trapper.name') : _ctx.addon,
    class: _normalizeClass(["addon-image", 'icon-' + _ctx.addon])
  }, null, 10, _hoisted_1))
}